var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid comment-count", class: _vm.commentClass },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "grid__col--11 h-no-margin h-no-padding" }, [
        _vm._v(_vm._s(_vm.commentCountText))
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "grid__col--1 h-no-padding h-center-align" },
      [_c("i", { staticClass: "far fa-comments" })]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }